import { RegionsPage } from "@/components/non_registrant/regions-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/government/regions")({
  component: function GovernmentRegionsRoute() {
    return <RegionsPage portal="government" />;
  },
});
